"use client";

import styled, { type CSSProperties } from "styled-components";

interface IInput {
  disabled?: boolean;
  currentValue: string;
  placeholder: string;
  styles?: CSSProperties;
  title: string;
  color: string;
  backgroundColor: string;
  valueChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const JNJInput = styled.div<{
  $disabled: boolean;
  $color: string;
  $backgroundColor: string;
}>`
  height: fit-content;
  min-width: fit-content;
  min-height: 40px;
  display: flex;
  min-width: 200px;
  width: 100%;
  max-width: 300px;

  .input-container {
    display: flex;
    flex-direction: column;
    position: relative;
    flex: 1;
  }

  .title {
    position: absolute;
    top: -14px;
    left: 12px;
    z-index: 1;
    padding: 0px 4px;
    font-size: 0.8rem;
    text-align: left;
    font-weight: 400;
    background-color: ${(props) => props.$backgroundColor};
    color: ${(props) =>
      props.$disabled ? `${props.theme.lightGrey}` : `${props.$color}`};
  }

  input {
    background-color: ${(props) => props.theme.white};
    border: 1px solid
      ${(props) =>
        props.$disabled ? `${props.theme.lightGrey}` : `${props.$color};`};
    border-radius: 5px;
    padding: 10px;
    position: relative;
    transition: none;
    font-size: 1rem;
    color: ${(props) =>
      props.$disabled ? `${props.theme.lightGrey}` : `${props.theme.black};`};
    font-weight: 500;
    line-height: 10px;
    display: inline-block;
    width: 100%;
  }

  input:focus {
    animation: none;
  }

  input:focus-visible {
    outline: none;
  }
`;

export function TextField({
  currentValue,
  disabled,
  placeholder,
  title,
  styles,
  color,
  backgroundColor,
  valueChangeHandler,
}: IInput) {
  return (
    <JNJInput
      $disabled={disabled || false}
      $color={color}
      style={{ ...styles }}
      $backgroundColor={backgroundColor}
    >
      <div className="input-container">
        <div className="title">{title}</div>
        <input
          value={currentValue || ""}
          onChange={valueChangeHandler}
          disabled={disabled}
          placeholder={placeholder}
        />
      </div>
    </JNJInput>
  );
}
